export default {
  getFornitoriPreferitiPercentage(state) {
    const val = state.partners.length > 2 ? 2 : state.partners.length;
    return parseInt((val / 2) * 100);
  },
};
